import React, { useEffect, useState } from "react";
import FoodCard from "./FoodCard";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

// Module-level cache to persist products across navigations
let cachedProducts = null;

const FeaturedProducts = ({ selectedCategory }) => {
  const [products, setProducts] = useState(cachedProducts || []);
  const [loading, setLoading] = useState(!cachedProducts);

  useEffect(() => {
    // If products are already cached, no need to fetch
    if (cachedProducts) return;

    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const items = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setProducts(items);
        cachedProducts = items; // Store in module-level cache
      } catch (err) {
        console.error("Firestore fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = selectedCategory
    ? products.filter(
        (product) =>
          product.category &&
          product.category.toLowerCase() === selectedCategory.toLowerCase()
      )
    : products;

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 p-8">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="animate-pulse p-4 rounded-lg border border-gray-200 shadow bg-white"
          >
            <div className="h-40 bg-gray-200 rounded mb-4" />
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2" />
            <div className="h-4 bg-gray-300 rounded w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (filteredProducts.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[150px] bg-white border border-gray-300 rounded-lg p-8 mx-4 my-6 shadow-md text-gray-700 text-center text-lg font-semibold">
        No items available for{" "}
        <span className="text-indigo-600 ml-1">{selectedCategory}</span>.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white p-4 px-2 md:p-8">
      <h2 className="text-xl md:text-2xl mb-6 font-semibold text-gray-800">
        {selectedCategory
          ? `Products: ${selectedCategory}`
          : "Featured Products"}
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-x-1 gap-y-4 lg:gap-y-8">
        {filteredProducts.map((product) => (
          <FoodCard key={product.id} {...product} />
        ))}
      </div>
    </div>
  );
};

export default FeaturedProducts;
